import { useEffect, useState } from "react"
import { Tabs, Tab } from "@mui/material"
import RechargeRequestItem from "@/components/recharge/RechargeRequestItem"
import { RechargeRequest } from "src/types/RechargementRequest"

type Filter = "ALL" | "VALIDATED" | "REJECTED"

const mockRequests: RechargeRequest[] = [
  {
    id: "1",
    date: "17/11/2024 16:20",
    client: "Tech Innovation",
    reference: "RCH-003",
    amount: 2500000,
    method: "Virement bancaire",
    description: "Virement bancaire pour recharge du compte wallet",
    status: "VALIDATED",
  },
  {
    id: "2",
    date: "17/11/2024 16:20",
    client: "Tech Innovation",
    reference: "RCH-004",
    amount: 1500000,
    method: "Virement bancaire",
    description: "Recharge wallet",
    status: "REJECTED",
  },
  {
    id: "3",
    date: "17/11/2024 16:20",
    client: "Tech Innovation",
    reference: "RCH-005",
    amount: 900000,
    method: "Virement bancaire",
    description: "Recharge wallet",
    status: "VALIDATED",
  },
  {
    id: "4",
    date: "17/11/2024 17:20",
    client: "Tech Innovation",
    reference: "RCH-006",
    amount: 950000,
    method: "Virement bancaire",
    description: "Recharge wallet",
    status: "PENDING",
  },
]

const AccountRecharge = () => {
  const [requests, setRequests] = useState<RechargeRequest[]>(mockRequests)
  const [filter, setFilter] = useState<Filter>("ALL")
  const [filteredRequests, setFilteredRequests] = useState<RechargeRequest[]>([])

  const handleValidate = (id: string) => {
    setRequests((prev) =>
      prev.map((r) =>
        r.id === id ? { ...r, status: "VALIDATED" } : r
      )
    )
  }

  const handleReject = (id: string) => {
    setRequests((prev) =>
      prev.map((r) =>
        r.id === id ? { ...r, status: "REJECTED" } : r
      )
    )
  }

  useEffect(() => {
    const newRequests = requests.filter((r) => {
      if (filter === "ALL") {
        return true
      }
      if (filter === "VALIDATED") return r.status === "VALIDATED"
      if (filter === "REJECTED") return r.status === "REJECTED"
      return false
    })

    setFilteredRequests(newRequests)
  }, [filter])

  useEffect(() => {
    console.log("filteredRequests", filteredRequests)
  }, [filteredRequests])
  return (
    <div className="space-y-4">
      {/* FILTER TABS */}
      <Tabs
        value={filter}
        onChange={(_, value) => setFilter(value)}
        TabIndicatorProps={{ style: { display: "none" } }}
        sx={{
          backgroundColor: "#F3F4F6",
          borderRadius: "10px",
          padding: "4px",
          width: "fit-content",
        }}
      >
        <Tab label="Toutes" value="ALL" sx={tabStyle} />
        <Tab label="Validées" value="VALIDATED" sx={tabStyle} />
        <Tab label="Rejetées" value="REJECTED" sx={tabStyle} />
      </Tabs>

      <div className="space-y-3">
        {filteredRequests.length === 0 && (
          <p className="text-sm text-gray-500">
            Aucune demande à afficher
          </p>
        )}

        {filteredRequests.map((req) => (
          <RechargeRequestItem
            key={req.id}
            request={req}
            onValidate={handleValidate}
            onReject={handleReject}
          />
        ))}
      </div>
    </div>
  )
}

const tabStyle = {
  textTransform: "none",
  fontWeight: 500,
  fontSize: "14px",
  minHeight: "32px",
  padding: "6px 16px",
  borderRadius: "8px",
  color: "#6B7280",
  fontFamily: "inherit",
  "&.Mui-selected": {
    backgroundColor: "#FFFFFF",
    color: "#111827",
  },
}

export default AccountRecharge
